import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.7 17.3C8.51667 17.1167 8.425 16.8833 8.425 16.6C8.425 16.3167 8.51667 16.0833 8.7 15.9L12.6 12L8.7 8.09999C8.51667 7.91665 8.425 7.68332 8.425 7.39999C8.425 7.11665 8.51667 6.88332 8.7 6.69999C8.88334 6.51665 9.11667 6.42499 9.4 6.42499C9.68334 6.42499 9.91667 6.51665 10.1 6.69999L14.7 11.3C14.8 11.4 14.871 11.5083 14.913 11.625C14.9543 11.7417 14.975 11.8667 14.975 12C14.975 12.1333 14.9543 12.2583 14.913 12.375C14.871 12.4917 14.8 12.6 14.7 12.7L10.1 17.3C9.91667 17.4833 9.68334 17.575 9.4 17.575C9.11667 17.575 8.88334 17.4833 8.7 17.3Z",
		fill: "currentColor"
	})
});
export default SvgChevronRight;
